// Canonical tier boundaries. All breakpoint comparisons in JS must use these
// constants rather than raw magic numbers.
export const MOBILE_MAX = 799;   // ≤799 → mobile  (canvas: min(375px,100%))
export const DESKTOP_MIN = 1160; // ≥1160 → desktop (two-page spread, 1500px canvas)
                                 // 800–1159 → tablet (canvas: 800px, single page)
// 1160–1499 renders the full desktop two-page canvas shrunk to 80% (zoom) so it
// fits below full size; ≥1500 renders the canvas at 100%. See DESKTOP_SCALED_MAX.
export const DESKTOP_SCALED_MAX = 1499; // 1160–1499 → desktop layout at 80% scale

/**
 * Maps a viewport width to the current tier name.
 * @param {number} viewportWidth
 * @returns {'mobile' | 'tablet' | 'desktop'}
 */
export function getTier(viewportWidth) {
  if (viewportWidth <= MOBILE_MAX) return "mobile";
  if (viewportWidth < DESKTOP_MIN) return "tablet";
  return "desktop";
}
